<template>
  <div>
    <div class="card mb-3">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="info-block">
              <h5><span class="info-label">Job Name:</span> {{ jobRegister.name }}</h5>
            </div>
          </div>
          <div class="col-12">
            <div class="info-block">
              <h5><span class="info-label">Client Name:</span> {{ jobRegister.contact_profile_name }}</h5>
            </div>
          </div>
          <div class="col-4">
            <div class="info-block">
              <h5><span class="info-label">Agreement No:</span> {{ jobRegister.bill_number }}</h5>
            </div>
          </div>
          <div class="col-4">
            <div class="info-block">
              <h5><span class="info-label">Agreement Date:</span> {{ jobRegister.bill_date }}</h5>
            </div>
          </div>
          <div class="col-4">
            <div class="info-block">
              <h5><span class="info-label">Fees:</span> {{ jobRegister.bill_amount }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header-label">
        <h3>Job Timeline</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-4">
            <div class="info-block">
              <h5><span class="info-label">Est. Start Date:</span>{{ jobRegister.start_date }}</h5>
            </div>
          </div>
          <div class="col-4">
            <div class="info-block">
              <h5><span class="info-label">Est. End Date:</span>{{ jobRegister.end_date }}</h5>
            </div>
          </div>
          <div class="col-4">
            <div class="info-block">
              <h5><span class="info-label">Compliance Deadline:</span>{{ jobRegister.compliance_deadline }}</h5>
            </div>
          </div>
          <div class="col-4">
            <div class="info-block">
              <h5><span class="info-label">Actual Start Date:</span></h5>
            </div>
          </div>
          <div class="col-4">
            <div class="info-block">
              <h5><span class="info-label">Actual Completion Date:</span></h5>
            </div>
          </div>
        </div>

        <div class="card-header-label mt-2">
          <h3>Revised Deadline</h3>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
            <tr>
              <th>Requested By</th>
              <th>Requested Date</th>
              <th>Approved By</th>
              <th>Approved Date</th>
              <th>Approver Note</th>
            </tr>
            </thead>
            <tbody>
            <tr>
               <td></td>
               <td></td>
               <td></td>
               <td></td>
               <td></td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header-label">
        <h3>Team Members & Timesheet</h3>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table custom-table-padding">
            <thead>
            <tr>
              <th>Role</th>
              <th>Team Member</th>
              <th>Est. Time (Hrs.)</th>
              <th>Actual Time (Hrs.)</th>
              <th>Hourly Rate</th>
              <th>Actual Team Cost</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in timeSheetItems" :key="i">
              <td>{{ item.role_name }}</td>
              <td>{{ item.full_name }}</td>
              <td>{{ item.estimated_time }}</td>
              <td>{{ item.total_hours }}</td>
              <td>{{ commaFormat(item.contact_person_fees) }}</td>
              <td>{{ commaFormat(item.total_hours * item.contact_person_fees) }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="2" class="text-center">Total</th>
              <th>{{ sum('estimated_time') }}</th>
              <th>{{ sum('total_hours') }}</th>
              <th>{{ commaFormat(sum('contact_person_fees')) }}</th>
              <th>{{ commaFormat(totalSum()) }}</th>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import handleProjects from "@/services/modules/procurement/project";
import {computed, inject, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import figureFormatter from "@/services/utils/figureFormatter";

const {fetchJobRegisterByProject} = handleProjects()
const jobRegister = ref({});
const timeSheetItems = ref([]);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const store = useStore()
const router = useRouter();
const route = useRoute();
const {commaFormat} = figureFormatter()

const projectId = computed(() => {
  return route.query.projectId ? route.query.projectId : '';
});

const getProjectMaster = async () => {
  const res = await fetchJobRegisterByProject(projectId.value, getQuery());
  if (! res.status) {
     showError(res.message)
     return;
  }
  let data = res.data;
  jobRegister.value = data.data;
  timeSheetItems.value = data.time_sheet;
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

const sum = (column) => {
  return timeSheetItems.value.reduce((total, i) => total + parseFloat(i[column]), 0);
}

const totalSum = () => {
  let total = 0;
  timeSheetItems.value.forEach((item)=>{
    total += item.total_hours * item.contact_person_fees
  })
  return total;
}

watch(() => route.query.projectId, async (newValue) => {
  await getProjectMaster()
})

onMounted(async () => {
  await getProjectMaster()
});

</script>

<style scoped>
.info-label {
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  letter-spacing: 0.05em;
  margin-bottom: 3px;
  line-height: 20px;
}

.card-header-label {
  background: #e8eaf6;
  color: #2c3e6b;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 10px 10px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border-bottom: 1px solid #d0d5e8;
}
</style>
